import { HeaderPet } from "./HeaderPet";
import { HeaderRoot } from "./HeaderRoot";
import { HeaderStore } from "./HeaderStore";

export const Header = {
  Root: HeaderRoot,
  Store: HeaderStore,
  Pet: HeaderPet,
}
